const DEFAULT_BOOK_COVER =
  'https://cxacypehrzratbpjeivm.supabase.co/storage/v1/object/public/uploads/covers/default_book_cover.png';

export function getBookCoverUrl(path) {
  if (!path || typeof path !== 'string') {
    return DEFAULT_BOOK_COVER;
  }
  
  if (path.startsWith('http')) {
    return path;
  }
  
  return `https://cxacypehrzratbpjeivm.supabase.co/storage/v1/object/public/${path}`;
}

export default getBookCoverUrl;